import React from 'react'

interface FooterProps {
  language?: 'zh' | 'en'
}

const LINKS = [
  { label: 'Taijiquanday.com', url: 'https://taijiquanday.com' },
  { label: 'Wudanghub.com', url: 'https://wudanghub.com' },
  { label: 'Wudangtimechamber.com', url: 'https://wudangtimechamber.com' },
]

const Footer: React.FC<FooterProps> = () => {
  return (
    <footer className="bg-wudang-blue text-white py-8">
      <div className="container mx-auto px-4">
        {/* Contact Email */}
        <div className="flex justify-center mb-6">
          <div className="flex items-center space-x-2 text-white/80 hover:text-wudang-gold transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <a href="mailto:info@hellowudang.com" className="text-sm">
              info@hellowudang.com
            </a>
          </div>
        </div>
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-6 text-sm">
          {LINKS.map((link) => (
            <a
              key={link.url}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-wudang-gold transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer